module.exports = __webpack_public_path__ + "img/help1-2-2.ec3365c7.png";